import React from 'react';

import { colors } from '@assets/colors';
import { Grid, Typography } from '@mui/material';

interface IContentSeparatorProps {
    title: string;
    variant?: any;
}

export const ContentSeparator: React.FC<IContentSeparatorProps> = ({ title, variant = 'subtitle1' }) => (
    <Grid item xs={12} style={{ marginTop: '2rem', marginBottom: '1rem', backgroundColor: colors.gray6, borderRadius: 4, color: colors.black1, padding: '6px 8px' }}>
        <Typography variant={variant}>{title}</Typography>
    </Grid>
);
